<script lang="ts">
    const component = {
        name: 'Partial_NodeDelayFields',
    };

    export default {
        name: component.name,
    };
</script>

<script lang="ts" setup>
    import { computed, inject } from 'vue';
    import { JourneyNode } from '@journeys/Journeys.viewmodel';
    import FormInput from '@shared/components/Form/FormInput.vue';
    import { injectorAccessInjectionKey } from '@cwd/lib/provider-keys';
    import { FeatureService } from '@shared/directives/Feature.service';

    const injectorAccess = inject(injectorAccessInjectionKey)!;
    const featureAccess: FeatureService = injectorAccess.injector.get(FeatureService);

    const props = withDefaults(
        defineProps<{
            node: JourneyNode;
            showIntervalLabel?: boolean;
        }>(),
        {
            showIntervalLabel: false,
        }
    );

    const delayDays = computed({
        get: () => props.node.data.delay_d,
        set: (value) => (props.node.data.delay_d = parseInt(value as any)),
    });

    const delayHours = computed({
        get: () => props.node.data.delay_h || 0,
        set: (value) => (props.node.data.delay_h = parseInt(value as any)),
    });

    const delayMinutes = computed({
        get: () => props.node.data.delay_m || 0,
        set: (value) => (props.node.data.delay_m = parseInt(value as any)),
    });

    const intervalDays = computed({
        get: () => props.node.data.delay_interval_d || 0,
        set: (value) => (props.node.data.delay_interval_d = parseInt(value as any) || 0),
    });

    const intervalHours = computed({
        get: () => props.node.data.delay_interval_h || 0,
        set: (value) => (props.node.data.delay_interval_h = parseInt(value as any) || 0),
    });

    const intervalMinutes = computed({
        get: () => props.node.data.delay_interval_m || 0,
        set: (value) => (props.node.data.delay_interval_m = parseInt(value as any) || 0),
    });
</script>

<template>
    <h3 class="h4">{{ $Resources.GenericDelayLabel }}</h3>

    <h4 class="h5 m-xs-b">{{ $Resources.DelayMin }}</h4>

    <div class="form-group d-flex gap-lg">
        <FormInput type="number" :min="0" v-model="delayDays" :label="$Resources.DelayLabelDays"></FormInput>

        <FormInput type="number" :min="0" v-model="delayHours" :label="$Resources.DelayLabelHours"></FormInput>

        <template v-if="featureAccess.hasFeature('BackOffice')">
            <FormInput type="number" :min="0" v-model="delayMinutes" :label="$Resources.DelayLabelMinutes"></FormInput>
        </template>
    </div>

    <template v-if="!showIntervalLabel">
        <h4 class="h5 m-xs-b">{{ $Resources.DelayMax }}</h4>

        <div class="form-group d-flex gap-lg">
            <FormInput type="number" :min="0" v-model="intervalDays" :label="$Resources.DelayLabelDays"></FormInput>

            <FormInput type="number" :min="0" v-model="intervalHours" :label="$Resources.DelayLabelHours"></FormInput>

            <template v-if="featureAccess.hasFeature('BackOffice')">
                <FormInput type="number" :min="0" v-model="intervalMinutes" :label="$Resources.DelayLabelMinutes"></FormInput>
            </template>
        </div>
    </template>

    <template v-else>
        <h4 class="h5 m-xs-b">{{ $Resources.DelayMax }}</h4>

        <div class="form-group">
            <h4 class="h5 m-xs-b">{{ $Resources.DelayIntervalLabel }}</h4>
            <div class="d-flex gap-lg">
                <FormInput type="number" :min="0" v-model="intervalDays" :label="$Resources.DelayLabelDays"></FormInput>

                <FormInput type="number" :min="0" v-model="intervalHours" :label="$Resources.DelayLabelHours"></FormInput>

                <template v-if="featureAccess.hasFeature('BackOffice')">
                    <FormInput type="number" :min="0" v-model="intervalMinutes" :label="$Resources.DelayLabelMinutes"></FormInput>
                </template>
            </div>
        </div>
    </template>
</template>

